import { Container, Grid2 } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";
// import AppStore from "../assets/images/app-store.png";
// import PlayStore from "../assets/images/play-store.png";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Grid2 container spacing={2} className="footer-inner">
          <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
            <div className="footer-logo">
              <Link to={"/"}>
                <img src={Logo} alt="" />
              </Link>
            </div>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <div className="footer-links-wrap">
              <ul className="footer-links">
                {/* <li>
                  <Link>Privacy</Link>
                </li> */}
                <li>
                  <Link to={"/terms-of-use"}>Terms of Use</Link>
                </li>
                <li>
                  <Link to={"/privacy-policy"}>Privacy Policy</Link>
                </li>
                {/* <li>
                  <Link to={"/faqs"}>Help & Support</Link>
                </li> */}
                {/* <li>
                  <Link>Swiggy Home</Link>
                </li> */}
              </ul>
              {/* <div className="app-links-wrap">
                <ul className="app-links">
                  <li className="mb-12">
                    <Link>Download App</Link>
                  </li>
                  <li>
                    <Link>
                      <img src={AppStore} alt="" />
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <img src={PlayStore} alt="" />
                    </Link>
                  </li>
                </ul>
              </div> */}
            </div>
          </Grid2>
        </Grid2>
        <Grid2 container spacing={2}>
          <Grid2 size={{ lg: 8, md: 12 }} className="footer-text">
            <p className="text-med-emphasis">
              By continuing past this page, you agree to our Terms of service,
              Cookie policy, Privacy policy and Content policies. All trademarks
              are properties of their respective owners. 2016-2021 © Swiggy
              Limited. All rights reserved
            </p>
          </Grid2>
        </Grid2>
      </Container>
    </footer>
  );
};

export default Footer;
